<template>
  <Page>
    <section class="statrate-container">
      <Announce style="margin-top: 8px;" />
      <Breadcrumb title="运价数据库" wstyle="margin-left: -16px; padding-left: 16px;" />
      <ListFilter :formList="filterFormList" @search="searchHandle" />
      <div class="rate-list">
        <div class="rate-list-header">
          <div class="rate-list-header-left">
            <span class="rate-list-header-left-title">共{{total}}条（有效：{{ validTotal }} 失效：{{ invalidTotal }}）</span>
          </div>
          <div class="rate-list-header-right">
            <span>优先价格最低</span>
            <el-dropdown trigger="click" popper-class="rate-list-dropdown-wrap">
              <span class="el-dropdown-link">
                <span>{{sortByContainerType}}</span>
                <el-icon><arrow-down /></el-icon>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item v-for="(item, index) in [ '全部', ...Object.keys(CONST.CONTAINER_TYPE_LABEL) ]" @click="listSortHandle('ASC', item)">{{ item }}</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </div>
        <div class="rate-list-body">
          <div class="rate-list-body-item" v-for="(item, index) in list" v-if="list?.length > 0">
            <!-- 列表item -->
            <div class="main">
              <div class="main-column">
                <div class="carrier-info">
                  <div class="carrier-logo" :style="{ backgroundImage: `url(${item?.carrierLogoUrl})` }" />
                  <div class="carrier-order-number">
                    <div class="number-value">{{item?.contractNumber}}<span class="status" :class="{invalid: CONST.FREIGHT_RATES_STATUS_INVALID == item.status}" v-if=item?.status>{{CONST.FREIGHT_RATES_STATUS_LABEL[item?.status]}}</span></div>
                    <div class="number-date">
                      <span>约有效期至 {{rateDateFormat(item?.expiryDate)}}</span>
                      <span v-if="item?.route">{{item?.route}}</span>
                      <span v-if="item?.commodity">{{ item?.commodity }}</span>
                    </div>
                  </div>
                </div>
                <div class="carrier-date-info">
                  <div class="item"><em /><el-tooltip :content="item?.porName"><span class="span">{{item?.porName}}</span></el-tooltip></div>
                  <div class="space">
                    <el-dropdown placement="top-start" v-if="item?.transferItemVOS && item?.transferItemVOS.length > 0">
                      <span class="carrier-date-info-sign">{{ item.transferItemVOS[0]?.portName }}</span>
                      <template #dropdown v-if="item?.transferItemVOS.length > 1">
                        <el-dropdown-menu>
                          <el-dropdown-item v-for="(transferItemVOSItem, transferItemVOSIndex) in item.transferItemVOS">{{transferItemVOSItem?.portName}}</el-dropdown-item>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                    <em />
                  </div>
                  <div class="item"><em /><el-tooltip :content="item?.porName"><span class="span">{{ item?.pdlName }}</span></el-tooltip></div>
                </div>
              </div>
              <div class="main-column main-column-right">
                <div class="rate-price-info">
                  <div class="title">海运费({{ item.containerPriceVOS && item.containerPriceVOS[0]?.currency || '' }})</div>
                  <div class="rate-price-detail">
                    <div class="item" v-for="(priceItem, priceIndex) in [null, null, null, null]">
                      <span class="container">{{item.containerPriceVOS && item.containerPriceVOS[priceIndex]?.containerType || ''}}</span>
                      <span class="price">{{ratePriceFormat(item.containerPriceVOS && item.containerPriceVOS[priceIndex]?.price || '')}}</span>
                    </div>
                  </div>
                </div>
                <div class="rate-price-detail-btn" @click="getDetail(item, index)">
                  <span>详细价格信息</span>
                  <el-icon>
                    <ArrowDown color="#4EBE41" v-if="!(detailIndex == index && detailList?.length > 0)" />
                    <ArrowUp color="#4EBE41" v-if="detailIndex == index && detailList?.length > 0" />
                  </el-icon>
                </div>
              </div>
              <div class="rate-price-valid-date" v-if="item?.validFrom || item?.validTo">运价有效期：{{rateDateFormat(item?.validFrom)}}~{{rateDateFormat(item?.validTo)}}</div>
            </div>
            <!-- 下拉详情 -->
            <div class="detail" v-if="detailIndex == index && detailList?.length > 0">
              <el-table
                :data="detailList"
                style="width: 100%; color: #232326;"
                :header-cell-style="{ fontWeight: 500, color: '#232326', backgroundColor: '#F8F9FA' }"
                :span-method="objectSpanMethod"
              >
                <el-table-column prop="priceCategory" label="费用类别" width="208" />
                <el-table-column prop="priceName" label="费用名称" width="440" />
                <el-table-column label="币种">
                  <template #default="scope">{{scope.row.containerPrices[0].currency}}</template>
                </el-table-column>
                <el-table-column v-for="(detailContainerItem, detailContainerIndex) in detailList[0].containerPrices" :key="detailContainerIndex">
                  <template #header>{{detailList[0].containerPrices[detailContainerIndex]?.containerType}}</template>
                  <template #default="scope">{{ratePriceFormat(scope.row.containerPrices[detailContainerIndex]?.price)}}</template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="" v-if="loading == 2 && !list?.length"><Empty /></div>
          <Spagination
            wstyle="margin-top: 24px"
            :page="page"
            :size="size"
            :total="total"
            @current-change="val => page = val"
          />
        </div>
      </div>
    </section>
  </Page>
</template>

<script setup>
  import {onMounted, ref, watch} from 'vue';
  import momemt, { invalid } from 'moment'
  import { ArrowDown, ArrowUp, User } from '@element-plus/icons-vue'

  import * as Request from '@/assets/request';
  import * as CONST from '@/assets/const';
  import * as Utils from '@/assets/utils';

  import Announce from '@/components/announce';
  import Empty from '@/components/empty';
  import Page from '@/components/page';
  import Breadcrumb from '@/components/breadcrumb';
  import ListFilter from '@/components/listFilter';
  import Spagination from '@/components/spagination';
  import { ElMessage } from 'element-plus';

  const ratePriceFormat = p => {
    if(!p) return '';
    return p.toFixed(2);
  }
  const rateDateFormat = d => {
    if(!d) return '';
    return d.replace(/-/ig, '.');
  }

  const statusOptions = Object.keys(CONST.FREIGHT_RATES_STATUS_LABEL).map(value => ({ value: Number(value), label: CONST.FREIGHT_RATES_STATUS_LABEL[value] }))

  /**
   * 列表筛选
   */
  const filterFormList = ref([])
  const filterFormListInit = async () => {
    const contractNumber = Utils.getSearchByKey('contractNumber');
    filterFormList.value = [
      {
        type: 'select-search', field: 'carrierCode',
        label: '承运人', placeholder: '请选择',
        remoteMethodUrl: '/10031/gis/carrier/search_keyword_list',
        remoteMethodQuery: {
          carrierType: 1,
          filterIsEnable: 1,
          usableChannelIds: [],
        },
        optionItemFormat: item => {
          if(item?.typeVO?.id == 1) {
            return {
              value: item.carrierCode,
              label: item.carrierName
            }
          }
          return null;
        },
      },
      {
        type: 'input', field: 'contractNumber',
        label: '合约号', placeholder: '请输入',
        value: contractNumber || undefined
      },
      {
        type: 'select-search', field: 'porCode',
        label: '起运地', placeholder: '请选择',
        remoteMethodUrl: '/10031/port/search/searchSimplePort',
        remoteMethodQuery: {
          ids: [],
          portStatus: 1,
          portTypes: [1,2,4],
          usableChannels: [2]
        },
        optionItemFormat: item => ({
          ...item,
          value: item.unCode,
          label: item.englishName
        }),
      },
      {
        type: 'select-search', field: 'pdlCode',
        label: '目的地', placeholder: '请选择',
        remoteMethodUrl: '/10031/port/search/searchSimplePort',
        remoteMethodQuery: {
          ids: [],
          portStatus: 1,
          portTypes: [1,2,4],
          usableChannels: [2]
        },
        optionItemFormat: item => ({
          ...item,
          value: item.unCode,
          label: item.englishName
        }),
      },
      {
        // 默认值 有效
        type: 'select', field: 'status', value: statusOptions[0].value,
        label: '状态', placeholder: '请选择',
        options: statusOptions
      },
      {
        type: 'select', field: 'containerType',
        label: '箱型', placeholder: '请选择',
        options: Object.keys(CONST.CONTAINER_TYPE_LABEL).map(value => ({ value: value, label: CONST.CONTAINER_TYPE_LABEL[value] }))
      },
    ];
  }
  onMounted(() => {
    filterFormListInit()
  });

  /**
   * 列表排序
   */
  const sortByContainerType = ref('全部');
  const listSort = ref([])
  const listSortHandle = (direction, property) => {
    sortByContainerType.value = property;

    // 清空
    if(property == '全部') {
      listSort.value = [];
      return;
    }

    // 更新替换
    let flag = 'new';
    if(Object.keys(CONST.CONTAINER_TYPE_LABEL).includes(property)) {
      listSort.value.map(lst => {
        if(lst.property && Object.keys(CONST.CONTAINER_TYPE_LABEL).includes(lst.property)) {
          flag = 'old'
          lst.property = property;
        }
      })
    }else{
      listSort.value.map(lst => {
        if(lst[property]) {
          flag = 'old'
          lst[property] = property;
        }
      })
    }

    // 新增
    if(flag == 'new') {
      listSort.value.push({ property, direction });
    }
  }

  /**
   * 列表合并body
   */
  const spanArr = ref([]);
  const pos = ref(0);
  const getSpanArr = (data) => {
    spanArr.value = [];
    for (let i = 0; i < data.length; i++) {
      // 当为第一行时
      if (i === 0) {
        spanArr.value.push(1);
        pos.value = 0;
      } else {
        // 判断当前值是否与上一行的【名称】相等，相等则进行合并
        if (data[i].priceCategory === data[i - 1].priceCategory) {
          spanArr.value[pos.value] += 1; // 合并单元格：合并的行数 +1
          spanArr.value.push(0); // 0代表单元格是不需要显示, 已经被合并的单元格
        } else {
          spanArr.value.push(1); // 1代表当前这行的数据需要被显示
          pos.value = i;
        }
      }
    }
    console.log('spanArr.value', spanArr.value)
  }
  const objectSpanMethod = ({ row, column, rowIndex, columnIndex }) => {
    // 用于设置要合并的列(这里是指第一列合并)
    if (columnIndex === 0) {
      const _row = spanArr.value[rowIndex]; // 合并行数
      const _col = spanArr.value[rowIndex] > 0 ? 1 : 0; // 合并的列数
      return {
        rowspan: _row,
        colspan: _col,
      };
    }
  }

  /**
   * 列表数据
   */
  const list = ref([])
  const listQuery = ref({
    status: statusOptions[0].value
  })
  const total = ref(0)
  const validTotal = ref(0)
  const invalidTotal = ref(0)
  const size = ref(50)
  const page = ref(1)
  const loading = ref(0); // 0-初始；1-加载中；2-已加载
  const getList = async () => {
    loading.value = 1;
    const _query = {
      ...listQuery.value,
      page: page.value,
      size: size.value,
    }
    if(listSort.value?.length > 0) {
      _query.sort = listSort.value
    }
    const result = await Request.post({
      url: '/22001/facade/freight/rate/searchList',
      data: _query
    });
    loading.value = 2;
    if(result?.code != 200) return;

    list.value = result.data.content;
    if(list.value?.length > 0) {
      list.value.map(lst => {
        if(lst?.transferItemVOS?.length > 0 && lst?.porName?.indexOf(lst?.transferItemVOS[0]?.portName) != -1) {
          lst.transferItemVOS.shift();
        }
        return lst
      })
    }
    total.value = result.data.total;
    validTotal.value = result.data.validTotal;
    invalidTotal.value = result.data.invalidTotal;
  }
  onMounted(() => {
    getList()
  })
  onMounted(() => {
    getList()
  })
  watch(() => [ listQuery.value, page.value, listSort.value ], () => {
    getList();
  }, { deep: true });
  // detail for list
  const detailList = ref([]);
  const detailIndex = ref(null)
  const getDetail = async (item, index) => {
    if(detailList.value?.length > 0 && detailIndex.value == index) {
      detailList.value = [];
      detailIndex.value = null;
      return;
    }

    const containerTypes = item?.containerPriceVOS?.map(item => item.containerType);
    const result = await Request.post({
      url: '/22001/facade/freight/rate/getFreightRatePrice',
      data: {
        key: item?.key,
        containerTypes
      }
    });
    if(result?.code != 200) return;

    detailList.value = result?.data;
    detailIndex.value = index;

    getSpanArr(detailList.value);
  }

  // 搜索
  const searchHandle = data => {
    console.log('data', data)
    listQuery.value = {...data};
    page.value = 1;
  }
</script>

<style scoped lang="less">
@import "./index.less";
</style>
<style lang="less">
  .rate-list-dropdown-wrap{
    position: relative;
    .el-popper__arrow{
      display: none;
    }
  }
</style>